import { homeServerUrl } from "../environment/Environment";
import axiosInstance from "../external-library/axios-interceptor/Interceptor";

const getDownloadedReports = async () => {
  return await axiosInstance.get(`${homeServerUrl}/admin/downloaded-reports`);
};

const getDownloadedReportPdf = async (id) => {
  return await axiosInstance.get(
    `${homeServerUrl}/admin/downloaded-reports/${id}/pdf`,
    {
      responseType: "blob",
    }
  );
};

const deleteDownloadedReport = async (id) => {
  return await axiosInstance.delete(
    `${homeServerUrl}/admin/downloaded-reports/${id}`
  );
};

export {
  getDownloadedReports,
  getDownloadedReportPdf,
  deleteDownloadedReport,
};
